<template>
  <v-col cols="10" md="8" lg="6" class="elevation-2 rounded-xl pa-4 my-10">
    <h1 class="my-3">Ungefärlig nivå</h1>
    <v-text-field
      dir="auto"
      v-model="result.title"
      label="Titel"
      outlined
    ></v-text-field>
    <AddContent v-model="result.extracontent" />
    <v-textarea
      dir="auto"
      v-model="result.text"
      label="Beskrivning"
      outlined
    ></v-textarea>
    <ul>
      <li v-for="(option, i) in value.options" :key="i">
        <v-row>
          <v-col cols="8">
            <v-text-field
              label="text"
              v-model="result.options[i].label"
              outlined
            ></v-text-field>
          </v-col>
          <v-col cols="4">
            <v-select
              label="till nivå"
              :items="options"
              v-model="result.options[i].value"
              outlined
            ></v-select>
          </v-col>
        </v-row>
      </li>
    </ul>
  </v-col>
</template>

<script>
import AddContent from "./AddContent.vue";
export default {
  name: "CreateRough",
  props: {
    value: Object
  },
  components: {
    AddContent
  },
  data() {
    return {
      options: [
        { text: "a1", value: "a1" },
        { text: "b1", value: "b1" },
        { text: "c1", value: "c1" }
      ]
    };
  },
  computed: {
    result: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      }
    }
  }
};
</script>

<style scoped>
li {
  list-style-type: "-";
  padding-inline-start: 1ch;
}
</style>
